import React from 'react'
import "./RaikoCardInfoTypeOne.scss"


export default function RaikoCardInfoTypeOne(
    {
        title = "",
        titleLabel = "",
        items = [],
        iconClass = "",
        statusText = "",
        status,
        statusType = RaikoCardInfoTypeOneStatusTypes.PRIMARY,
        hasBottomChildren = false,
        children

    }) {
    return (
        <div className={"RaikoCardInfoTypeOneBaseContainer"}>
            <div className={"RaikoCardInfoTypeOneTitleContainer"}>
                <span className={"RaikoCardInfoTypeOneInfoTitle"}>
                    <div className={iconClass}/>
                    <div className={"infoContainer"}>
                        <span>{titleLabel}</span>
                        <p>{title}</p>
                    </div>
                </span>
                {status ? <span className={`orderState ${statusType}`}> {statusText}</span> : ""}
            </div>
            <div className={"showOrderInfoContent"}>
                <div className={"showOrderPaidItemContainer"}>
                    {
                        items && items.length > 0 && items.map((item, index) => {
                            return <span className={"orderAttribute"} key={index}>
                                <span className={"orderAttributeTitle"}>{item.title}</span>
                                <span className={"orderAttributeValue"}>{item.value}</span>
                            </span>
                        })
                    }
                </div>

            </div>

            {
                hasBottomChildren ? <div className={"raikoCardInfoDivider"}/> : <></>
            }

            {
                hasBottomChildren ? children : <></>
            }

        </div>
    )
}

export function RaikoCardInfoTypeOneItemGenerator(title, value) {
    return {
        title,
        value
    }
}

export const RaikoCardInfoTypeOneStatusTypes = {
    "PRIMARY": "",
    "SUCCESS": "orderStateSuccess",
    "ERROR": "orderStateError",
    "WARNING": "orderStateWarning",
}
